import { Button, Form, Input, Modal } from "antd";
import { useCallback, useState } from "react";

const password = 'P14mos0f!2025'

function ConfirmPasswordButton({ onClick, confirmTitle, confirmContent, ...rest }) {
  const [open, setOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  const onOk = useCallback(async () => {
    form.submit()
    const values = form.getFieldsValue();
    if(values.password === password) {
      onClick()
      setOpen(false)
    }
    
  }, [form, onClick, setOpen])

  return <>
    <Modal
        title={confirmTitle}
        open={open}
        onOk={onOk}
        cancelText="Abbrechen"
        onCancel={() => setOpen(false)}
      >
        <>{ confirmContent }</>
       <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          autoComplete="off"
        >
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, pattern: new RegExp(`^${password}$`), message: 'Bitte Passwort eingeben' }]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
    </Modal>
    <Button {...rest} onClick={() => setOpen(true)} />
    </>
}

export default ConfirmPasswordButton;